import { render, staticRenderFns } from "./EmailInput.vue?vue&type=template&id=0bbc8b4f&scoped=true"
import script from "./EmailInput.vue?vue&type=script&lang=js"
export * from "./EmailInput.vue?vue&type=script&lang=js"
import style0 from "./EmailInput.vue?vue&type=style&index=0&id=0bbc8b4f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bbc8b4f",
  null
  
)

export default component.exports